import { render, staticRenderFns } from "./strat-footer.vue?vue&type=template&id=62b573a8&scoped=true&"
import script from "./strat-footer.vue?vue&type=script&lang=js&"
export * from "./strat-footer.vue?vue&type=script&lang=js&"
import style0 from "./strat-footer.vue?vue&type=style&index=0&id=62b573a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b573a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VDialog,VFlex,VLayout})
